import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.96258 12.5837V7.03709H0.416016V5.96356H5.96258V0.416992H7.03611V5.96356H12.5827V7.03709H7.03611V12.5837H5.96258Z" })
});
export default SvgAddIcon;
